import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PushNotificationRoutingModule } from './push-notification-routing.module';
import { PushNotificationLandingComponent } from './push-notification-landing/push-notification-landing.component';
import { PushNotificationLinkComponent } from './push-notification-link/push-notification-link.component';
import { PushNotificationComponent } from './push-notification/push-notification.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@NgModule({
  declarations: [
    PushNotificationLandingComponent,
    PushNotificationLinkComponent,
    PushNotificationComponent
  ],
  imports: [
    CommonModule,
    PushNotificationRoutingModule,
    AcademicFormModule,
    AgGridModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatCardModule,
    MatTableModule,
    MatDatepickerModule,
    MatInputModule,
    MatProgressSpinnerModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
  ]
})
export class PushNotificationModule { }
